import { Injectable } from '@angular/core';
import { UpdateOrderParams } from '@features/order/services/order-api/order-api.service';
import { ShoppingCartPhysicalDeliveryFormData } from '@rd/form-builder/types/shopping-cart-delivery-form-data.type';
import { Order } from '@rd/types/order.type';
import deepmerge from 'deepmerge';
import { IntentionalUndefined } from 'global-types';

@Injectable({
  providedIn: 'root',
})
export class UpdateOrderApiAdapter {
  // TODO: Create a hook to apply "countryCode" AU.
  // Because there is just one whitelabel that has shopping cart/update order API, we can
  // safely use "AU" as country code. We have to remove/extract the countryCode functionality
  // later.
  convert({
    id,
    formData,
    email,
  }: {
    id: Order['id'];
    formData: ShoppingCartPhysicalDeliveryFormData;
    email: string | IntentionalUndefined;
  }): UpdateOrderParams {
    // email is IntentionalUndefined because user.type email can be undefined - see note there.
    //  We will attempt to send formData email, then the user email, then null.

    let params: UpdateOrderParams = {
      id,
      order: {
        recipient: {
          firstName: formData.firstName,
          lastName: formData.lastName,
          phoneNumber: formData.phoneNumber || null,
          email: formData.email || (email ?? null),
          companyName: formData.companyName || null,
          address: null,
        },
      },
    };

    // Can potentially result in a case where the user has an addressLine 1, but has no address. We might need a `type` field in `ShoppingCartDeliveryFormData` etc. Can do it later.
    if (formData.addressLine1) {
      params = deepmerge(params, {
        order: {
          recipient: {
            address: {
              city: formData.city || null,
              countryCode: formData.addressLine1 ? 'AU' : null, // TODO: Remove hardcoded AU here - similar to GiftCardHelper/AnzGiftCardHelper pattern
              full_address: formData.fullAddress || null,
              line_1: formData.addressLine1 || null,
              line_2: formData.addressLine2 || null,
              postalCode: formData.postalCode || null,
              state: formData.state || null,
            },
          },
        },
      });
    }
    return params;
  }
}
